import script from "./ColorTextPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorTextPopover.vue?vue&type=script&setup=true&lang=js"

import "./ColorTextPopover.vue?vue&type=style&index=0&id=53978d1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53978d1a"]])

export default __exports__